import React, { useState,useEffect } from 'react';
import { FaAddressCard, FaUser, FaCheckCircle, FaFileAlt } from 'react-icons/fa'; // For Icons
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import axios from 'axios';


const MultiStepForm = () => {

  const BaseUrl = process.env.REACT_APP_API;
  

  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [ClientData, setClientData] = useState([]);
  const [signatureURL, setSignatureURL] = useState('');
  const [countries, setCountry] = useState([]);




  const steps = [
    { name: 'Company Info', icon: <FaAddressCard onClick={() => setCurrentStep(0)} /> },
    { name: 'Contact Info', icon: <FaUser onClick={() => setCurrentStep(1)} /> },
    { name: 'KYC Documents', icon: <FaFileAlt onClick={() => setCurrentStep(2)} /> },
    { name: 'Declaration', icon: <FaCheckCircle onClick={() => setCurrentStep(3)} /> },
  ];
  const navigate = useNavigate();

  const [isRegulatoryApplicable, setIsRegulatoryApplicable] = useState(false);
  const [isSeniorManagementApplicable, setIsSeniorManagementApplicable] = useState(false);
  const [isExternalAuditorApplicable, setIsExternalAuditorApplicable] = useState(false);

  const handleRegulatoryCheckboxChange = (event) => {
    setIsRegulatoryApplicable(event.target.checked);
  };

  const handleSeniorManagementCheckboxChange = (event) => {
    setIsSeniorManagementApplicable(event.target.checked);
  };

  const handleExternalAuditorCheckboxChange = (event) => {
    setIsExternalAuditorApplicable(event.target.checked);
  };
 

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await fetch(`${BaseUrl}/countries`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setCountry(data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };
    fetchCountries();
  }, [BaseUrl]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const jwtToken = sessionStorage.getItem("authToken");
        if (!jwtToken) {
          navigate('/');
          throw new Error("JWT token not found in local storage");
        }

        // Verify token using your backend endpoint
        const tokenVerificationResponse = await axios.post(
          `${BaseUrl}/validate-token`,
          { token: jwtToken }
        );

        if (!tokenVerificationResponse.data.valid) {
          throw new Error("Token validation failed or expired");
        }

      
        const response = await axios.get(`${BaseUrl}/getCompanyInfo`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setClientData(response.data);
       
       
      } catch (error) {
        console.error(error.message || "Error fetching company data");
      }
    };

    fetchCompanyData();
  }, [BaseUrl]);



  // Handle Next Button Click
  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  // Handle Previous Button Click
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    navigate("/dashboard");
  };

  const formatDateToIST = (dateString) => {
    if (!dateString) return '';
  
    const date = new Date(dateString);
    
    const istOffset = 5.5 * 60 * 60 * 1000; 
    const localDate = new Date(date.getTime() + istOffset);
  
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/digital-signature/${ClientData[0]?.digital_signature}`, {
          responseType: 'blob',
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = URL.createObjectURL(blob);
        setSignatureURL(url);
      } catch (error) {
        console.error('Error fetching digital signature:', error);
      }
    };

    if (ClientData[0]?.digital_signature) {
      fetchSignature();
    }
  }, [ClientData[0]?.digital_signature]);

  return (
    <div id="msform" className="container mt-4 ">
      {/* Progress Bar */}
      <ul id="progressbar" className="progress-bar d-flex justify-content-around list-unstyled flex-row">
        {steps.map((step, index) => (
          <li
            key={index}
            className={`text-center ${index <= currentStep ? 'active' : ''}`}
            id={step.name.toLowerCase().replace(' ', '')}
          >
            <div className="step-icon mb-1">{step.icon}</div>
            <span>{step.name}</span>
          </li>
        ))}
      </ul>


     <Container className="mt-5" >
        <Form>
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 0 ? "block" : "none",
              borderRadius: "10px",
              boxShadow: "0px 0px 20px #748292",
              transition: "all 0.5s ease-in-out",
              textAlign:"left"
            }}
           
          >
            <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
            Company Info
            </h6>
            <hr
              style={{
                margin:"5px",
                border: "1px solid #748292",
                width: "100%",
              }}
            />

           
            <div className="row mb-3" >
              <label className="col-md-3 col-form-label text-start ">Name of the Institutione</label>
              <div className="col-md-9" >
                <input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Enter name of_ institution"
                  value={ClientData[0]?.name_of_institution ? ClientData[0]?.name_of_institution: 'N/A'}
                  readOnly
                />
              </div>
            </div>

          
            <div className="row mb-3">
              <label className="col-md-3 col-form-label text-start ">Company Legal Status</label>
              <div className="col-md-9">
                              <select
                                className="form-select"
                                id="legal_status"
                                name="legal_status"
                                value={                            
                                  ClientData[0]?.legal_status
                                }
                                readOnly
                              >
                                <option value="">Select</option>
                                <option value="Single Person Company (SPC)">
                                  Single Person Company (SPC)
                                </option>
                                <option value="With Limited Liability (WLL)">
                                  With Limited Liability (WLL)
                                </option>
                                <option value="Partnership Company">
                                  Partnership Company
                                </option>
                                <option value="Limited Partnership by Shares">
                                  Limited Partnership by Shares
                                </option>
                                <option value="Bahraini Shareholding Company (BSC)">
                                  Bahraini Shareholding Company (BSC)
                                </option>
                                <option value="Bahraini Shareholding Company (BSC Closed)">
                                  Bahraini Shareholding Company (BSC Closed)
                                </option>
                                <option value="Foreign Company Branch (Represenatative Office)">
                                  Foreign Company Branch (Represenatative
                                  Office)
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                              Country of Incorporation
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="country_of_incorporation"
                                name="country_of_incorporation"
                                value={
                                  ClientData[0]?.country_of_incorporation
                                }
                               readOnly
                              >
                                <option value="">Select</option>

                                {countries.map((country) => (
                                  <option
                                    key={country.NumCode}
                                    value={country.NumCode}
                                  >
                                    {country.Country}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

          
            <div className="mb-3 row">
                            <label className="col-md-3 col-form-label mt-1">
                              Company Registration Number
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="registration_number"
                                name="registration_number"
                                value={
                                  ClientData[0]?.registration_number
                                }
                               readOnly
                              />
                            </div>
                          </div>

           
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Date of Incorporation
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="date"
                                id="incorporation_date"
                                name="incorporation_date"
                                value={                                 
                                  ClientData[0]?.incorporation_date
                                }
                                readOnly
                              />
                            </div>
                          </div>

            
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label mt-1">
                              Registering Authority
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="registering_authority"
                                name="registering_authority"
                                value={
                                  ClientData[0]?.registering_authority
                                }
                               readOnly
                              />
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label mt-1">
                              Business Activity
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="business_activity"
                                name="business_activity"
                                value={
                                  ClientData[0]?.business_activity
                                }
                               readOnly
                              />
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                              Annual Turnover (US$ Millions)
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="annual_turnover"
                                name="annual_turnover"
                                value={
                                  ClientData[0]?.annual_turnover
                                }
                                readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">Less than 50</option>
                                <option value="2">51-99</option>
                                <option value="3">100-250</option>
                                <option value="4">251- 500</option>
                                <option value="5">501 - 1,000</option>
                                <option value="6">Above 1,000</option>
                              </select>
                            </div>
                          </div>
           
                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                            Type of Profile
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="type_of_profile"
                                name="type_of_profile"
                                value={
                                  ClientData[0]?.type_of_profile
                                }
                                readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">Resident</option>
                                <option value="2">Non- resident</option>
                              </select>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                            Type of Account
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="type_of_account"
                                name="type_of_account"
                                value={
                                  ClientData[0]?.type_of_account
                                }
                               readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">Individual</option>
                                <option value="2">Entity</option>
                              </select>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                            Nature of Account
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="nature_of_account"
                                name="nature_of_account"
                                value={
                                  ClientData[0]?.nature_of_account
                                }
                                readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">Investment in Equities</option>
                                <option value="2">Investment in Securities</option>
                                <option value="3">Investment in Bonds</option>
                                <option value="4">Investment in Commodities</option>
                                <option value="5">Investment in Mutual Funds</option>
                                <option value="6">Investment in Stocks</option>
                                <option value="7">Investment in Digital Assets</option>
                              </select>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                            Anticipated Volume
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="anticipated_volume"
                                name="anticipated_volume"
                                value={
                                  ClientData[0]?.anticipated_volume
                                }
                                readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">1 - 100,000 USD</option>
                                <option value="2">100,000 - 500,000 USD</option>
                                <option value="3">500,000 - 1,000,000 USD</option>
                                <option value="4">1,000,000 - 10,000,000 USD</option>
                                <option value="5">10,000,000 - 50,000,000 USD</option>
                              </select>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                            Source of Funds
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="source_of_funds"
                                name="source_of_funds"
                                value={
                                  ClientData[0]?.source_of_funds
                                }
                               readOnly
                              >
                              <option value="">Select</option>
                              <option value="1">Salary</option>
                              <option value="2">Business Activity</option>
                              <option value="3">Savings</option>
                              <option value="4">Pension</option>
                              <option value="5">Inheritance</option>
                              <option value="6">Gift</option>
                              <option value="7">Bonus</option>
                              <option value="8">Indemnity/End of Service Payment</option>
                              <option value="9">Return on Investments</option>
                              <option value="10">Other</option>
                              </select>
                              {/* {selectedOption === '10' && (
                              <div>
                                <label htmlFor="source_of_funds">Enter Source of Funds</label>
                                <input
                                  type="text"
                                  id="other-income"
                                  value={otherIncome}
                                  onChange={handleOtherIncomeChange}
                                  placeholder="Enter details"
                                />
                              </div>
                            )} */}
                            </div>
                          </div>
            
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label mt-1">
                            Purpose And Intended Nature Of The Business Relationship  </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="purpose_and_intended_nature_of_business"
                                name="purpose_and_intended_nature_of_business"
                                value={
                                  ClientData[0]?.purpose_and_intended_nature_of_business
                                }
                                readOnly
                              />
                            </div>
                          </div>


                          <div className="row mb-3">
                            <label className="col-md-3 col-form-label">
                              No. of Employees
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-select"
                                id="no_of_employees"
                                name="no_of_employees"
                                value={
                                  ClientData[0]?.no_of_employees
                                }
                               readOnly
                              >
                                <option value="">Select</option>
                                <option value="1">
                                  Less Than 10 Employees
                                </option>
                                <option value="2">11-25 Employees</option>
                                <option value="3">26-50 Employees</option>
                                <option value="4">51-99 Employees</option>
                                <option value="5">100-500 Employees</option>
                                <option value="6">Above 500 Employees</option>
                              </select>
                            </div>
                          </div>

                          {!ClientData[0]?.regulatory_body? <div className="row mb-2">
            <div className="col-md-12">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="is_regulatory_applicable"
                  checked={isRegulatoryApplicable}
                />
                <label htmlFor="is_regulatory_applicable" className="form-check-label ms-2">
                  Regulatory Body or Listing Body If Applicable
                </label>
              </div>
             
            </div>
            </div>:""}

            {(isRegulatoryApplicable || ClientData[0]?.regulatory_body) && (
            <div className="mb-3 row">
              <label className="col-md-3 col-form-label mt-1">
                Regulatory Body or Listing Body
              </label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  type="text"
                  id="regulatory_body"
                  name="regulatory_body"
                  value={
                    ClientData[0]?.regulatory_body
                  }
                  maxLength={100}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Enter Regulatory Body or Listing Body"
                  
                />
              </div>
            </div>
          )}

  {!ClientData[0]?.senior_management_names?<div className="form-check mt-2 mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="is_senior_management_applicable"
                  checked={isSeniorManagementApplicable}
                />
                <label htmlFor="is_senior_management_applicable" className="form-check-label ms-2">
                  Names of Relevant Persons in Senior Management If Applicable
                </label>
              </div> :""}
    

              {(isSeniorManagementApplicable || ClientData[0]?.senior_management_names) && (
            <div className="mb-2 mt-2 row">
              <label className="col-md-3 col-form-label mt-1">
                Names of Relevant Persons in Senior Management
              </label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  type="text"
                  id="senior_management_names"
                  name="senior_management_names"
                  value={
                    ClientData[0]?.senior_management_names
                  }
                  maxLength={200}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Enter Names of Relevant Persons in Senior Management"
                />
              </div>
            </div>
          )}

 {!ClientData[0]?.external_auditor_name? <div className="form-check mt-1  mb-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="is_external_auditor_applicable"
                  checked={isExternalAuditorApplicable}
                  
                />
                <label htmlFor="is_external_auditor_applicable" className="form-check-label ms-2">
                  Name of External Auditor If Applicable
                </label>
              </div> :""}

              {(isExternalAuditorApplicable || ClientData[0]?.external_auditor_name) && (
            <div className="mb-3 row">
              <label className="col-md-3 col-form-label mt-1">
                Name of External Auditor
              </label>
              <div className="col-md-9">
                <input
                  className="form-control"
                  type="text"
                  id="external_auditor_name"
                  name="external_auditor_name"
                  value={
                    ClientData[0]?.external_auditor_name
                  }
                  maxLength={100}
                 
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Enter the name of the external auditors"
                />
              </div>
            </div>
          )}

          </fieldset>

          </Form>

            

       {/* contact info */}
        <fieldset
          style={{
           textAlign:"left",
           display: currentStep === 1 ? "block" : "none"}}
           >
           
          <div  style={{
            margin: "10px",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0px 0px 20px #748292",
            transition: "all 0.5s ease-in-out"}} >
              <h6 className="text-start " style={{ marginBottom: "0.7rem" }}>Contact Info</h6>
              <hr  style={{
                border: "1px solid #748292",
                margin: "5px",
                width: "100%",
              }}/>
            <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Address(1)
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="address1"
                                name="address1"
                                value={
                                  ClientData[0]?.address1
                                }
                              
                                maxLength={100}
                                readOnly
                               
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Address(2){" "}
                              <small className="text-muted">(Optional)</small>
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="address2"
                                name="address2"
                                value={
                                   ClientData[0]?.address2
                                }
                                
                                readOnly
                                maxLength={100}
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label
                              htmlFor="city"
                              className="col-md-3 col-form-label"
                            >
                              Location
                            </label>
                            <div className="col-md-3 custom-spacing">
                              <input
                                className="form-control"
                                type="text"
                                placeholder="City *"
                                id="city"
                                name="city"
                                value={ClientData[0]?.city}
                                
                                maxLength={50}
                                readOnly
                                required
                              />
                            </div>
                            <div className="col-md-3  custom-spacing">
                              <input
                                className="form-control"
                                type="text"
                                id="pobox"
                                name="pobox"
                                value={ClientData[0]?.pobox}
                                
                                maxLength={100}
                                readOnly
                                placeholder="PO Box (Optional)"
                              />
                            </div>
                            <div className="col-md-3  custom-spacing">
                              <select
                                className="form-select"
                                id="country"
                                name="country"
                                value={ClientData[0]?.country}
                                readOnly
                              >
                                <option value="">Select</option>
                                {countries.map((country) => (
                                  <option
                                    key={country.NumCode}
                                    value={country.NumCode}
                                  >
                                    {country.Country}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Telephone
                            </label>
                            <div className="col-md-9">
                              {/* <PhoneInput
                                country={"in"} // Default country code
                                value={phone}
                                onChange={handlePhoneChange}
                                inputProps={{
                                  name: "telephone",
                                  required: true,
                                  className: "form-control",
                                  id: "telephone",
                                }}
                              /> */}
                              <input
                                className="form-control"
                                name="telephone"
                                value={
                                  ClientData[0]?.telephone
                                }
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Fax{" "}
                              <small className="text-muted">(Optional)</small>
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="tel"
                                id="fax"
                                name="fax"
                                value={ClientData[0]?.fax}
                                readOnly
                                maxLength={100}
                              />
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              E-Mail
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="email"
                                id="email"
                                name="email"
                                value={ ClientData[0]?.email}
                                readOnly
                                maxLength={100}
                                
                              />
                             </div>
                          </div>
                          

                          <div className="mb-3 row">
                            <label className="col-md-3 col-form-label">
                              Website{" "}
                            </label>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                type="text"
                                id="website"
                                name="website"
                                value={ ClientData[0]?.website}
                                maxLength={100}
                                readOnly
                              />
                            </div>
                          </div>
            
          </div>
        </fieldset>





          {/* KYC Documents */}
          <fieldset
            style={{
              padding: "20px",
              display: currentStep === 2 ? "block" : "none",
            }}>
            <div
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
             
            >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Document Uploaded
              </h6>
              <hr
                style={{
                  border: "1px solid #748292",
                  margin: "5px",
                  width: "100%",
                }}
              />

              {/* <p className="text-muted text-start mb-4">
                The file size must be under 10 MB and only PDF format is accepted.
              </p> */}

<div className="mb-3 row">
        <label htmlFor="commercial_registration" className="col-md-3 col-form-label">
          Commercial Registration
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="commercial_registration"
            name="commercial_registration"
            accept="application/pdf"
            disabled={ClientData[0]?.commercial_registration}
            required={!ClientData[0]?.commercial_registration}
          />
          {ClientData[0]?.commercial_registration && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="vat_registration" className="col-md-3 col-form-label">
          VAT Registration Certificate
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="vat_registration"
            name="vat_registration"
            accept="application/pdf"
            disabled={ClientData[0]?.vat_registration}
            required={!ClientData[0]?.vat_registration}
          />
          {ClientData[0]?.vat_registration && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="company_registration" className="col-md-3 col-form-label">
          Company Registration Extract
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="company_registration"
            name="company_registration"
            accept="application/pdf"
            disabled={ClientData[0]?.company_registration}
            required={!ClientData[0]?.company_registration}
          />
          {ClientData[0]?.company_registration && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="authorized_signatory_proof" className="col-md-3 col-form-label">
          Identification documentation of the Authorised Signatory
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="authorized_signatory_proof"
            name="authorized_signatory_proof"
            accept="application/pdf"
            disabled={ClientData[0]?.authorized_signatory_proof}
            required={!ClientData[0]?.authorized_signatory_proof}
          />
          {ClientData[0]?.authorized_signatory_proof && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="memorandum_of_association" className="col-md-3 col-form-label">
          Memorandum of Association
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="memorandum_of_association"
            name="memorandum_of_association"
            accept="application/pdf"
            disabled={ClientData[0]?.memorandum_of_association}
            required={!ClientData[0]?.memorandum_of_association}
          />
          {ClientData[0]?.memorandum_of_association && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="articles_of_association" className="col-md-3 col-form-label">
          Articles of Association
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="articles_of_association"
            name="articles_of_association"
            accept="application/pdf"
            disabled={ClientData[0]?.articles_of_association}
            required={!ClientData[0]?.articles_of_association}
          />
          {ClientData[0]?.articles_of_association && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="partnership_agreement" className="col-md-3 col-form-label">
          Partnership Agreement
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="partnership_agreement"
            name="partnership_agreement"
            accept="application/pdf"
            disabled={ClientData[0]?.partnership_agreement}
            required={!ClientData[0]?.partnership_agreement}
          />
          {ClientData[0]?.partnership_agreement && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="board_resolution" className="col-md-3 col-form-label">
          Board Resolution
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="board_resolution"
            name="board_resolution"
            accept="application/pdf"
            disabled={ClientData[0]?.board_resolution}
            required={!ClientData[0]?.board_resolution}
          />
          {!ClientData[0]?.board_resolution && (
            <small className="text-muted">
              (Only Required For Private Or Unlisted Companies)
            </small>
          )}
          {ClientData[0]?.board_resolution && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>

      <div className="mb-3 row">
        <label htmlFor="list_of_authorized_signatories" className="col-md-3 col-form-label">
          List of Authorized Signatories
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="list_of_authorized_signatories"
            name="list_of_authorized_signatories"
            accept="application/pdf"
            disabled={ClientData[0]?.list_of_authorized_signatories}
            required={!ClientData[0]?.list_of_authorized_signatories}
          />
          {!ClientData[0]?.list_of_authorized_signatories && (
            <small className="text-muted">
              (Certification Not Required for GCC/FATF Listed Companies)
            </small>
          )}
          {ClientData[0]?.list_of_authorized_signatories && (
            <span className="badge bg-success ">Submitted</span>
          )}
        </div>
      </div>
       
      <div className="mb-3 row">
        <label htmlFor="latest_final_report_and_accounts" className="col-md-3 col-form-label">
          Latest Financial Report and Accounts
        </label>
        <div className="col-md-9">
          <input
            className="form-control"
            type="file"
            id="latest_final_report_and_accounts"
            name="latest_final_report_and_accounts"
            accept="application/pdf"
            disabled={ClientData[0]?.latest_final_report_and_accounts}
            required={!ClientData[0]?.latest_final_report_and_accounts}
          />
          {!ClientData[0]?.latest_final_report_and_accounts && (
            <small className="text-muted">
              (Audited Copies Do Not Require Certification)
            </small>
          )}
          {ClientData[0]?.latest_final_report_and_accounts && (
            <span className="badge bg-success mt-2">Submitted</span>
          )}
        </div>
      </div>
            </div>
          </fieldset>

       <fieldset
            style={{
              textAlign:"left",
              padding: "20px",
              display: currentStep === 3 ? "block" : "none", // Adjust for currentStep
            }}>
            <div
              style={{
                padding: "25px",
                borderRadius: "10px",
                boxShadow: "0px 0px 20px #748292",
                transition: "all 0.5s ease-in-out",
              }}
              >
              <h6 className="text-start" style={{ marginBottom: "0.5rem" }}>
                Declarations
              </h6>
              <hr
                style={{
                  marginBottom: "0.5rem",
                  width:"100%",
                  border: "1px solid #748292"
                }}/>

          {/* Declaration Text */}
          {/* <div className=" mb-3"
          >
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration1"
            checked={isChecked1}
            onChange={(e) => setIsChecked1(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration1">
            I/We confirm that I/we are acting on my/our behalf for the purpose of
            transactions, new accounts or providing any further information required
            by Blue Aster Capital BSC ©.
          </label>
        </div> */}

        {/* <div className=" mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration2"
            checked={isChecked2}
            onChange={(e) => setIsChecked2(e.target.checked)}
            required/>
          <label className="form-check-label" htmlFor="declaration2">
            I/We confirm the information provided above is true, accurate and
            complete. I/we consent to share information with regulators or tax
            authorities where necessary.
          </label>
        </div> */}

        {/* <div className="mb-3">
          <input
            type="checkbox"
            className="form-check-input"
            id="declaration3"
            checked={isChecked3}
            onChange={(e) => setIsChecked3(e.target.checked)}
            required
          />
          <label className="form-check-label" htmlFor="declaration3">
            I/We agree to notify Blue Aster Capital BSC © within 30 calendar days
            of any change in the provided information.
          </label>
        </div> */}


              {/* Name / Authorised Signatory Name */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Name / Authorised Signatory Name
                </label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control shadow-sm"
                    placeholder="Enter your name"
                    required
                  />
                </div>
              </div> */}

              {/* Digital Signature */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Digital Signature
                </label>
                <div className="col-md-9">
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "100%",
                      height: "150px",
                      position: "relative",
                    }}>
                    <canvas
                      ref={(canvasRef) => {
                        if (canvasRef) {
                          const ctx = canvasRef.getContext("2d");
                          canvasRef.addEventListener("mousedown", (e) => {
                            ctx.isDrawing = true;
                            ctx.beginPath();
                            ctx.moveTo(e.offsetX, e.offsetY);
                          });

                          canvasRef.addEventListener("mousemove", (e) => {
                            if (ctx.isDrawing) {
                              ctx.lineTo(e.offsetX, e.offsetY);
                              ctx.stroke();
                            }
                          });

                          canvasRef.addEventListener("mouseup", () => {
                            ctx.isDrawing = false;
                          });

                          canvasRef.addEventListener("mouseleave", () => {
                            ctx.isDrawing = false;
                          });
                        }
                      }}
                      width="500"
                      height="150"
                      style={{ width: "100%", height: "100%" }}
                    ></canvas>
                    <button
                      type="button"
                      className="btn btn-danger mt-2"
                      style={{ position: "absolute", bottom: "-40px", right: "0" }}
                      onClick={() => {
                        const canvas = document.querySelector("canvas");
                        const ctx = canvas.getContext("2d");
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div> */}


              {/* Date */}
              {/* <div className="row mb-3">
                <label className="col-md-3 col-form-label text-start ">
                  Date
                </label>
                <div className="col-md-9">
                  <input
                    type="date"
                    className="form-control shadow-sm"
                    required
                  />
                </div>
              </div> */}
                <div className="declaration-signature">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="acting_on_my_behalf"
              name="acting_on_my_behalf"
              checked={ClientData[0]?.acting_on_my_behalf}
            />
            <label className="form-check-label" htmlFor="declaration1">
              I/We hereby confirm that I/we are acting and would, in future will
              also be acting on my/our behalf for the purpose of transactions,
              new accounts or providing any further information required by Blue
              Aster Capital BSC ©.
            </label>
          </div>
          <div className="form-check d-flex align-items-center ">
            <input
              className="form-check-input"
              type="checkbox"
              id="acting_on_behalf_of"
              name="acting_on_behalf_of"
              checked={ ClientData[0]?.acting_on_behalf_of}
            />
            <label className="form-check-label ms-2" htmlFor="declaration2">
              I/We hereby confirm that I/we are acting on behalf of
            </label>
            <input
              type="text"
              className="form-control ms-2"
              id="acting_on_behalf_name"
              name="acting_on_behalf_name"
              placeholder="Enter name"
              style={{ maxWidth: '300px' }} 
              value={ ClientData[0]?.acting_on_behalf_name}
              readOnly
            />
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="information_true"
              name="information_true"
              checked={ClientData[0]?.information_true}
            />
          <label className="form-check-label" htmlFor="declaration3">
          I/We hereby confirm the information provided above is true, accurate
            and complete. Subject to applicable local laws, I/we hereby consent
            for Blue Aster Capital BSC © or any of its affiliates to share our
            information with domestic or overseas regulators or tax authorities
            where necessary.
            </label>
            </div>
            <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="notify_on_change"
              name="notify_on_change"
              checked={ClientData[0]?.notify_on_change}
            />
            <label className="form-check-label" htmlFor="declaration4">
            I/We agree and undertake to notify Blue Aster Capital BSC © within
            30 calendar days if there is a change in any information which I/we
            have provided.
          </label>
          </div>
          <div className="form-group mt-3">
            <label htmlFor="name">Name / Authorised Signatory Name:</label>
            <input
              type="text"
              className="form-control"
              id="signatory_name"
              name="signatory_name"
              placeholder="Enter your name"
              value={ClientData[0]?.signatory_name}
            />
          </div>
          {signatureURL && (
       
       <div className="mt-3">
          <img src={signatureURL} alt="Your Signature" />
        </div>
      )}
  
          <div className="form-group">
            <label htmlFor="date">Date:</label>
            <input
              type="date"
              className="form-control"
              id="declaration_date"
              name="declaration_date"
              value={ClientData[0]?.declaration_date}
            />
          </div>
          
        </div>

            </div>
          </fieldset>



      {/* Action buttons */}
      <div className="action-button-container" style={{textAlign:"center"}}>
        <button
          type="button"
          className="action-button-previous"
          onClick={handlePrevious}
          style={{ display: currentStep === 0 ? 'none' : 'block' }}
        >
          Previous
        </button>

        {/* Show "Next" or "Submit" based on the current step */}
        {currentStep === steps.length - 1 ? (
          <button
            type="button"
            className="action-button"
            onClick={handleSubmit} // Assuming handleSubmit handles form submission
          >
            Next
          </button>
        ) : (
          <button
            type="button"
            className="action-button"
            onClick={handleNext}
            style={{ display: currentStep === steps.length - 1 ? 'none' : 'block' }}
          >
            Next
          </button>
        )}
      </div>
      </Container>

    </div>
  );
};

export default MultiStepForm;
